export * as backlog from './backlog'
export * as design from './design'
export * as discovery from './discovery'
export * as sprint1 from './sprint-1'
export * as sprint2 from './sprint-2'
export * as sprint3 from './sprint-3'
export * as sprint4 from './sprint-4'
export * as sprint5 from './sprint-5'
export * as sprint6 from './sprint-6'
export * as sprint7 from './sprint-7'
export * as sprint8 from './sprint-8'
export * as sprint9 from './sprint-9'
export * as sprint10 from './sprint-10'
export * as sprint11 from './sprint-11'
export * as sprint12 from './sprint-12'
export * as sprint13 from './sprint-13'
export * as sprint14 from './sprint-14'
export * as testing from './testing'
export * as training from './training'
